<template lang="pug">
.laudo-listagem.w-100
    .tabela(v-if='tableData.length > 0')
        el-table.w-100.my-3.rolagem-tabela-laudo(
            :data='tableData',
            @sort-change='sortChangeRequest',
            stripe,
            height='1000'
        )
            el-table-column(
                prop='codigo',
                :label='$t("laudos.gridColunaHash")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.codigo || '--' }}
            el-table-column(
                prop='informacaoLaudo.nomeTerritorio',
                :label='$t("laudos.territorio")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.informacaoLaudo?.nomeTerritorio || '--' }}
            el-table-column(
                prop='informacaoLaudo.car.codigo',
                :label='$t("laudos.car")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.informacaoLaudo?.car?.codigo || '--' }}
            el-table-column(
                prop='dataCadastroFormatado',
                :label='$t("laudos.dataSolicitacao")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.dataCadastroFormatado || '--' }}
            el-table-column(
                prop='dataFinalizacaoFormatado',
                :label='$t("laudos.dataEntrega")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.dataFinalizacaoFormatado || '--' }}
            el-table-column(
                prop='situacao',
                :label='$t("laudos.situacao")',
                sortable
            )
                .template(slot-scope='scope')
                    div(
                        :class='["situacao", classeSituacao.get(scope.row.situacao.codigo)]'
                    ) {{ traduzirSituacao(scope.row.situacao.nome) }}

            el-table-column(
                prop='status',
                :label='$t("laudos.status")',
                sortable,
                align='left'
            )
                .template(slot-scope='scope')
                    div(
                        v-if='scope.row.status && scope.row.situacao.codigo === "PROCESSADO"',
                        :class='["status", scope.row.status.codigo.toLowerCase()]'
                    )
                        | {{ scope.row.status ? scope.row.status.nome : '-' }}

            el-table-column(
                v-if='showAnalystColumns',
                prop='usuarioSolicitacaoNome',
                :label='$t("mensagens.comuns.solicitante")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.usuarioSolicitacaoNome || '--' }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='nomeEmpresa',
                :label='$t("laudos.empresa")',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.nomeEmpresa || '--' }}
            el-table-column(
                v-if='showAnalystColumns',
                prop='id',
                label='ID',
                sortable='custom',
                align='left'
            )
                template(slot-scope='scope')
                    span {{ scope.row?.id || '--' }}
            el-table-column(
                :label='$t("mensagens.comuns.acoes")',
                align='left'
            )
                .template.d-flex.justify-content-left(slot-scope='scope')
                    el-dropdown.action-button(trigger='click')
                        span.el-dropdown-link
                            i.mdi.mdi-dots-vertical
                        el-dropdown-menu(slot='dropdown')
                            el-dropdown-item(
                                icon='el-icon-view',
                                @click.native='showModalVisualizacao(scope.row)'
                            ) {{ $t('laudos.visualizarLaudo') }}
                            el-dropdown-item(
                                v-if='!showAnalystColumns && scope.row.situacao.codigo === "PROCESSADO"',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('laudos.baixarLaudo') }}
                            el-dropdown-item(
                                v-if='showAnalystColumns && scope.row.situacao.codigo !== "EM_PROCESSAMENTO"',
                                icon='el-icon-download',
                                @click.native='downloadLaudo(scope.row)'
                            ) {{ $t('laudos.baixarResultado') }}

    EmptyResultLaudo(
        v-else,
        :semLaudoSelecionado='false',
        :p1='$t("mensagens.comuns.semDados")',
        :p2='$t("laudos.naoConseguimosLocalizarNenhumLaudo")'
    )
</template>

<script>
import LaudosService from '@/modules/laudos/services/LaudosService';
import { classe } from '@/modules/laudos/utils/laudoSituacao';
import EmptyResultLaudo from '@/modules/laudos/components/EmptyResultLaudo.vue';

export default {
    name: 'LaudoListagem',
    components: {
        EmptyResultLaudo
    },
    props: {
        tableData: {
            type: Array,
            required: true
        },
        showAnalystColumns: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            classeSituacao: classe
        };
    },
    methods: {
        traduzirSituacao(situacao) {
            const normalizedSituacao = situacao
                .toUpperCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/ /g, '-');

            return this.$t(`laudos.situacoes.${normalizedSituacao}`);
        },
        showModalVisualizacao(row) {
            this.$emit('handleModalLaudo', row.id);
        },
        sortChangeRequest(column) {
            let prop = column.prop;
            if (prop.includes('.')) {
                prop = prop.split('.')[1];
            }

            if (prop === 'dataCadastroFormatado') {
                prop = 'dataCadastro';
            }
            if (prop === 'dataFinalizacaoFormatado') {
                prop = 'dataFinalizacao';
            }

            const params = {
                order: column.order === 'ascending' ? 'ASC' : 'DESC',
                column: prop
            };

            this.$emit('handleSort', params);
        },
        downloadLaudo(laudo) {
            LaudosService.downloadLaudo(laudo.id)
                .then(() => {
                    this.$notify.success({
                        message: this.$t('laudos.downloadRealizadoComSucesso')
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('laudos.erro.erroAoRealizarDownload')
                    });
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela {
    max-height: 1400px;
}

.el-table {
    .cell {
        word-break: break-word !important;
    }

    .action-button {
        cursor: pointer;
    }
}

.status {
    border-radius: 50px;
    text-align: center;
    color: var(--black);
    max-width: 150px;
}

.conforme {
    border: 1px solid var(--success);
    background-color: var(--background-according);
}

.inconforme {
    border: 1px solid var(--danger);
    background-color: var(--nonconforming-report);
}

.buttonCard {
    background: var(--white);
    height: 60px;
    top: -15px;
    position: relative;
    padding: 10px;
}
</style>
